<div class="safety">
  <button type="button" nz-button nzType="default" class="safety-trigger" [translate]="'SECURITY_MEASURES.BTN'" (click)="showModal()">
    Меры безопасности
  </button>

  <nz-modal
    [(nzVisible)]="isVisible"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()"
    nzCentered
    [nzFooter]="null"
    nzClassName="safety-modal"
    nzWidth="600px"
  >
    <ng-container *nzModalContent>
      <div class="safety-modal__container">
        <h3 class="safety-modal__title" [translate]="'SECURITY_MEASURES.TITLE'">Безопасность</h3>
        <div class="safety-modal__content" [innerHTML]="'SECURITY_MEASURES.CONTENT' | translate"></div>
        <div class="safety-modal__content" [innerHTML]="'SECURITY_MEASURES.LINK' | translate"></div>
      </div>
      <button (click)="handleCancel()" class="safety-modal__btn" nz-button
              nzSize="large">
        {{'SECURITY_MEASURES.BTN_CLEAR' | translate}}
      </button>
    </ng-container>
  </nz-modal>
</div>
